import { Skeleton as MUISkeleton, SkeletonProps } from '@mui/material';

const Skeleton: React.FC<SkeletonProps> = ({ variant = 'rounded', height = 56, ...rest }) => (
  <MUISkeleton variant={variant} height={height} width="100%" {...rest} />
);

export default Skeleton;
